import { getFileNameFromFilepath } from './get-file-name-from-filepath';

export function getExtensionFromFilepath(filePath: string): string {
  const fileName = getFileNameFromFilepath(filePath);
  const extension = fileName.split('.').pop();
  return extension ? extension.toLowerCase() : '';
}
